import { getBaseUrl } from '../BaseUrl';

// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface BuyerGetBatteryListParams {
  page: number; // 필수
  size: number; // 필수
  carManufacturerId?: string; // 선택
  carModelId?: string; // 선택
  sortBy?: 'asc' | 'desc'; // 선택
  minPrice?: number; // 선택
  maxPrice?: number; // 선택
  filter?: string;
}

// BuyerBatteryEndpointsProps 정의
export interface BuyerBatteryEndpointsProps {
  get_battery_buyer_list: (params: BuyerGetBatteryListParams) => string;
  get_battery_buyer_damage_info: (batteryId: string) => string;
  get_battery_buyer_sellers: (batteryId: string) => string;
  get_battery_buyer_overview: (batteryId: string) => string;
  get_battery_buyer_measurements: (
    batteryId: string,
    page: number,
    size: number,
    category: string
  ) => string;
  get_battery_buyer_info: (batteryId: string) => string;
  get_battery_buyer_images: (
    batteryId: string,
    page: number,
    size: number
  ) => string;
  get_battery_buyer_models_years: (carModelId: string) => string;
  get_battery_buyer_manufacturers: () => string;
  get_battery_buyer_manufacturer_models: (carManufacturerId: string) => string;
}

// BuyerBatteryEndpoints 정의
export const BuyerBatteryEndpoints: BuyerBatteryEndpointsProps = {
  get_battery_buyer_list: (params) => {
    const queryParams = new URLSearchParams();

    // 필수 파라미터
    queryParams.append('page', params.page.toString());
    queryParams.append('size', params.size.toString());

    // 선택 파라미터
    if (params.carManufacturerId)
      queryParams.append('carManufacturerId', params.carManufacturerId);
    if (params.carModelId) queryParams.append('carModelId', params.carModelId);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.minPrice !== undefined)
      queryParams.append('minPrice', params.minPrice.toString());
    if (params.maxPrice !== undefined)
      queryParams.append('maxPrice', params.maxPrice.toString());
    if (params.filter) queryParams.append('filter', params.filter);

    return `${getBaseUrl()}/batteries?${queryParams.toString()}`;
  },
  get_battery_buyer_damage_info: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}`,
  get_battery_buyer_sellers: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/sellers`,
  get_battery_buyer_overview: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/overview`,
  get_battery_buyer_measurements: (batteryId, page, size, category) =>
    `${getBaseUrl()}/batteries/${batteryId}/measurements?page=${page}&size=${size}&category=${category}`,
  get_battery_buyer_info: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/info`,
  get_battery_buyer_images: (batteryId, page, size) =>
    `${getBaseUrl()}/batteries/${batteryId}/images?page=${page}&size=${size}`,
  get_battery_buyer_models_years: (carModelId) =>
    `${getBaseUrl()}/batteries/models/${carModelId}/years`,
  get_battery_buyer_manufacturers: () =>
    `${getBaseUrl()}/batteries/manufacturers`,
  get_battery_buyer_manufacturer_models: (carManufacturerId) =>
    `${getBaseUrl()}/batteries/manufacturers/${carManufacturerId}/models`,
};

export default BuyerBatteryEndpoints;
